"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatWeekNumber = void 0;
/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "" + weekNumber;
}
exports.formatWeekNumber = formatWeekNumber;
//# sourceMappingURL=formatWeekNumber.js.map